import { createApp, h, provide } from "vue";
import { createPinia } from "pinia";
import Vacancies from "../src/Vacancies.vue";
import { DefaultApolloClient } from "@vue/apollo-composable";
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client/core";

document.addEventListener("DOMContentLoaded", function () {
  createApp({
    setup() {
      provide(
        DefaultApolloClient,
        new ApolloClient({
          link: createHttpLink({
            uri: "https://eu-central-1-shared-euc1-02.cdn.hygraph.com/content/cluvdys600vr707uwxk3ph6my/master",
          }),
          cache: new InMemoryCache(),
        }),
      );
    },
    render: () => h(Vacancies),
  })
    .use(createPinia())
    .mount("#vacancies");

  document
    .querySelector('[data-elem-id="1711477085146"] a[href="#respond"]')
    .addEventListener("click", function () {
      if (document.forms?.form740538760?.elements?.region) {
        document.forms.form740538760.elements.region.value = "Неизвестен";
      }
      if (document.forms?.form740538760?.elements?.vacancy) {
        document.forms.form740538760.elements.vacancy.value = "Неизвестна";
      }
    });
});
